import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { ARBEITSZEIT_CREATE } from './graphql/mutation';
import {
  ArbeitszeitCreateMutation,
  ArbeitszeitCreateMutationVariables,
} from '../../../gql/graphql';

export function useArbeitszeitCreate() {
  const [execute, result] = useMutation<
    ArbeitszeitCreateMutation,
    ArbeitszeitCreateMutationVariables
  >(ARBEITSZEIT_CREATE, {
    refetchQueries: ['getArbeitszeitenByDateAndStandortId', 'GetToDos'],
    awaitRefetchQueries: true,
  });

  const arbeitszeitUpdate = useCallback(
    (variables: ArbeitszeitCreateMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return [arbeitszeitUpdate, result] as const;
}
